import { useEffect, useState } from "react";
import { usePlateEditorState, getEditorString } from "@udecode/plate-core";
import { clsx } from "clsx";

import type { Editor } from "./types";

export interface TextEditorCharacterCountProps {
  limit?: number;
  count?: number;
  onStateChange?: (isLimitReached: boolean) => void;
}

export const TextEditorCharacterCount = ({
  limit,
  count,
  onStateChange,
}: TextEditorCharacterCountProps) => {
  const editor = usePlateEditorState() as Editor;
  const characterCount =
    count ??
    (editor && editor.children.length
      ? getEditorString(editor, [])?.length
      : 0);
  const [isLimitReached, setIsLimitReaced] = useState(false);

  useEffect(() => {
    setIsLimitReaced(!!(limit && characterCount >= limit));
  }, [characterCount, limit]);

  useEffect(() => {
    onStateChange?.(isLimitReached);
  }, [onStateChange, isLimitReached]);

  return (
    <div
      className={clsx("TextEditorCharacterCount", {
        "TextEditorCharacterCount--error": isLimitReached,
      })}
    >
      {characterCount} {limit && `/ ${limit}`}
    </div>
  );
};
